export enum ProgramStatus {
  ACTIVE = 'Active',
  FAILED = 'Failed',
  COMPLETED = 'Completed',
  CANCELED = 'Canceled',
}
